import { ApiClient } from 'app/service/api-service'
import { PatientEndPoint } from './constant'
import { IParams } from './model/patient'

export const requestGetAppointmentPatientManagement = (params: IParams) =>
  ApiClient.Get({
    url: PatientEndPoint.PatientManagement.appointmentPatient,
    params: { params },
  })
